// removed by extract-text-webpack-plugin
module.exports = {"Main":"Services__Main__WLyTZ","SkillDiv":"Services__SkillDiv__3Z2dz","SkillTitle":"Services__SkillTitle__uAodc","Title":"Services__Title__2iwht","SwitchColor":"Services__SwitchColor__2yhzq","TitleText":"Services__TitleText__2xkYK","TitleSubText":"Services__TitleSubText__1dldj","SkillOverview":"Services__SkillOverview__3LzTM","ImageMobileOnly":"Services__ImageMobileOnly__2CRR_"};


//////////////////
// WEBPACK FOOTER
// ./client/src/containers/Home/Services/Services.css
// module id = 364
// module chunks = 0